import { render, staticRenderFns } from "./ResultsHistoryList.vue?vue&type=template&id=50486ed2"
import script from "./ResultsHistoryList.vue?vue&type=script&lang=js"
export * from "./ResultsHistoryList.vue?vue&type=script&lang=js"
import style0 from "./ResultsHistoryList.vue?vue&type=style&index=0&id=50486ed2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports